import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
const PIXEL_ID = '1497007874735639';
export function App() {
  useEffect(() => {
    const initPixel = () => {
      try {
        if ((window as any).fbq) return;
        const fbq = function (...args: any[]) {
          if ((fbq as any).callMethod) {
            ;
            (fbq as any).callMethod.apply(fbq, args);
          } else {
            ;
            (fbq as any).queue.push(args);
          }
        } as any;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        (window as any).fbq = fbq;
        (window as any)._fbq = fbq;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        (window as any).fbq('init', PIXEL_ID);
        (window as any).fbq('track', 'PageView');
      } catch (error) {
        console.warn('Meta Pixel initialization failed:', error);
      }
    };
    initPixel();
  }, []);
  return <SalesPage data-id="element-0" />;
}